import { render, staticRenderFns } from "./DotLoader.vue?vue&type=template&id=90df36b0&scoped=true&"
import script from "./DotLoader.vue?vue&type=script&lang=js&"
export * from "./DotLoader.vue?vue&type=script&lang=js&"
import style0 from "./DotLoader.vue?vue&type=style&index=0&id=90df36b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90df36b0",
  null
  
)

export default component.exports